// Port of api/fuel/app/classes/insights/ratings/designer.php

import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'
import Designer from 'offline/model/designer'

export default Segment.extend({
    name: 'designer',
    priority: 1,
    default_: false,
    requires: [],
    insight: false,
    detail: [],
    types: [Constants.TYPE_USER, Constants.TYPE_GROUP, Constants.TYPE_BUDDIES],
    run: function(type, owner, userIndex, detail, filter, vars) {

        var ratings = Util.query('\
            SELECT \
                r.game_id AS game, \
                AVG(r.rating_value) AS rating, \
                COUNT(r.rating_id) AS ratings \
            FROM \
                ( \
                    game_designer l \
                    JOIN \
                    rating r \
                    ON \
                    r.game_id = l.game_id \
                    AND \
                    r.user_id IN (' + Util.in(userIndex) + ') \
                    AND \
                    l.designer_id = ' + vars.id + ' \
                ) \
                JOIN \
                game g \
                ON \
                r.game_id = g.game_id \
                AND \
                g.game_type = 1 \
            GROUP BY \
                g.game_id \
            ORDER BY \
                g.game_name ASC \
        ')

        var games = []

        for (var i = 0; i < ratings.length; i++) {
            var rating = ratings[i]

            this._references.games.push(parseInt(rating.game, 10))

            games.push({
                id: parseInt(rating.game, 10),
                count: parseFloat(rating.ratings),
                rating: Math.round(parseFloat(rating.rating) * 10) / 10
            })
        }

        var designer = Designer.with_id(vars.id)

        return {
            designer: designer.get_name(),
            games: games
        }

    }
})
